import { AbstractControl, ValidatorFn } from '@angular/forms';

export * from './email-validator';
export * from './percentage-validator';

export function urlValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) {
      return null;
    }
    const urlPattern = /^(https?:\/\/[^\s$.?#].[^\s]*)$/i;
    const isValid = urlPattern.test(control.value);
    return isValid ? null : { invalidUrl: { value: control.value } };
  };
}

export function multiFieldValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return control.value?.length > 0
      ? null
      : { noData: { value: control.value } };
  };
}
